import {
  IPointCloudLoader,
  IPointCloudLoadParams,
  IPointCloudTileGeometry,
} from "./interface";
import { getZipResponse } from "./utils";
import { load } from "@loaders.gl/core";
import { LASLoader as LAS } from "@loaders.gl/las";
import { Box3, Vector3 } from "three";

export class LASLoader implements IPointCloudLoader {
  async load(
    params: IPointCloudLoadParams,
    abortController: AbortController
  ): Promise<IPointCloudTileGeometry> {
    const response = await getZipResponse(params.url as string, abortController);
    const data = await load(response, LAS, {
      fetch: { credentials: "include", signal: abortController.signal },
      las: { colorDepth: "auto", skip: 1, fp64: true },
    });

    const bbox = new Box3();
    // .setFromBufferAttribute(data.attributes.POSITION.value);
    // const tempPoint = new Vector3();
    // tempPoint.setfr(data.attributes.POSITION.value, i)
    // for (let i = 0; i < data.attributes.POSITION.value.length; i += 3) {
    //   bbox.expandByPoint(
    //     tempPoint.fromBufferAttribute(data.attributes.POSITION.value, i)
    //   );
    // }
    for (let i = 0; i < data.attributes.POSITION.value.length; i += 3) {
      bbox.expandByPoint(
        new Vector3(
          data.attributes.POSITION.value[i],
          data.attributes.POSITION.value[i + 1],
          data.attributes.POSITION.value[i + 2]
        )
      );
    }
    const center = new Vector3();
    bbox.getCenter(center);
    const offset = center.negate();
    bbox.translate(offset);
    const vertices = new Float32Array(data.attributes.POSITION.value.length); // xyz
    for (let i = 0; i < data.attributes.POSITION.value.length; i += 3) {
      vertices[i] = data.attributes.POSITION.value[i] + offset.x;
      vertices[i + 1] = data.attributes.POSITION.value[i + 1] + offset.y;
      vertices[i + 2] = data.attributes.POSITION.value[i + 2] + offset.z;
    }

    const color = new Float32Array(data.attributes.POSITION.value.length); // データからR, G, Bを抽出
    for (
      let i = 0, j = 0;
      i < data.attributes.COLOR_0.value.length;
      i += data.attributes.COLOR_0.size, j+=3
    ) {
      color[j] = data.attributes.COLOR_0.value[i] / 255; // 0-255で来るRGBを0-1に変換
      color[j + 1] = data.attributes.COLOR_0.value[i + 1] / 255; // 0-255で来るRGBを0-1に変換
      color[j + 2] = data.attributes.COLOR_0.value[i + 2] / 255; // 0-255で来るRGBを0-1に変換
    }

    return {
      vertices,
      color,
      offset,
      bbox,
    };

    // let unzipData = await this.getZipResponse(url, abortController);
    // if (!unzipData) {
    //   rejects();
    //   return;
    // }

    // const data = await load(unzipData, LASLoader, {
    //   fetch: { credentials: "include", signal: abortController.signal },
    //   las: { colorDepth: "auto", skip: 1, fp64: true },
    // }).catch((res) => {
    //   rejects();
    // });
    // let filtered = new Float32Array(
    //   (data.attributes.COLOR_0.value.length * 3) / 4
    // ); // R, G, B, alpha でくるデータからR, G, Bを抽出
    // let j = 0;
    // for (let i = 0; i < data.attributes.COLOR_0.value.length; i++) {
    //   if ((i + 1) % 4 !== 0) {
    //     // R, G, B, alpha で来るのでalphaをskip
    //     filtered[j] = data.attributes.COLOR_0.value[i] / 255; // 0-255で来るRGBを0-1に変換
    //     j++;
    //   }
    // }
    // /* position情報*/
    // /* pointOffsetの設定-> 元データのtranslate*/
    // this._offset = new Vector3(Infinity, Infinity, Infinity);
    // for (let i = 0; i < data.attributes.POSITION.value.length; i += 3) {
    //   this._offset.x =
    //     data.attributes.POSITION.value[i] < this._offset.x
    //       ? data.attributes.POSITION.value[i]
    //       : this._offset.x;
    //   this._offset.y =
    //     data.attributes.POSITION.value[i + 1] < this._offset.y
    //       ? data.attributes.POSITION.value[i + 1]
    //       : this._offset.y;
    //   this._offset.z =
    //     data.attributes.POSITION.value[i + 2] < this._offset.z
    //       ? data.attributes.POSITION.value[i + 2]
    //       : this._offset.z;
    // }
    // for (let i = 0; i < data.attributes.POSITION.value.length; i += 3) {
    //   data.attributes.POSITION.value[i] -= this._offset.x;
    //   data.attributes.POSITION.value[i + 1] -= this._offset.y;
    //   data.attributes.POSITION.value[i + 2] -= this._offset.z;
    // }
    // /* Float64 -> Float32に変換*/
    // const float32Array = new Float32Array(
    //   data.attributes.POSITION.value.length
    // );
    // for (let i = 0; i < data.attributes.POSITION.value.length; i++) {
    //   float32Array[i] = data.attributes.POSITION.value[i];
    // }
    // /* 変換してからBufferAttributeにセット*/
    // this._geometry.setAttribute(
    //   "position",
    //   new BufferAttribute(float32Array, data.attributes.POSITION.size)
    // );
    // this._geometry.setAttribute("color", new BufferAttribute(filtered, 3));

    // this._points.geometry = this._geometry;
    // this._points.material = this._material;
    // this._points.frustumCulled = false;

    // this._points.geometry.computeBoundingBox();
    // this._points.geometry.computeBoundingSphere();
  }
}
